export default __webpack_public_path__ + "static/media/michelle-vertical.5675c415.png";